/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S7_TitleInputs */

const en_guide_what_is_json_s7_title = /** @type {(inputs: Guide_What_Is_Json_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working with JSON day to day`)
};

const ko_guide_what_is_json_s7_title = /** @type {(inputs: Guide_What_Is_Json_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일상에서 JSON 다루기`)
};

const ja_guide_what_is_json_s7_title = /** @type {(inputs: Guide_What_Is_Json_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日々の開発で JSON を扱う`)
};

/**
* | output |
* | --- |
* | "Working with JSON day to day" |
*
* @param {Guide_What_Is_Json_S7_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s7_title = /** @type {((inputs?: Guide_What_Is_Json_S7_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S7_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s7_title(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s7_title(inputs)
	return ja_guide_what_is_json_s7_title(inputs)
});